import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { actions as baselineTaskActions } from '../../../actions/baselineTaskActions';
import LoadingIndicator from '../../Common/LoadingIndicator/LoadingIndicator';
import * as types from '../../../constants/actionTypes';
import Notification from '../../../components/Common/Notification';

class AllLocationsForm extends React.Component {
    constructor(props, context) {
        super(props, context);

        this.state = {
            searchResults: [],
            selectedResults: [],
            selectedToReceive: [],
            isLoading: false
        }
    }

    async componentDidMount() {
        if (this.props.isProjectsActive === true && this.props.isProjectIdRequiredForLocationTask === false && !this.props.projectId){
            await this.searchLocationsNoProject();
        } else {
            await this.searchLocationsByProject();
        }
    }

    componentDidUpdate = async (prevProps) => {
        if (this.props.projectId && this.props.projectId !== prevProps.projectId) {
            this.searchLocationsByProject();
        }
    }

    searchLocationsByProject = async () => {
        try {
            this.setState({ isLoading: true });
            const params = {
                baselineId: this.props.baselineId,
                projectId: this.props.projectId
            };
            const result = await this.props.baselineTaskActions.bulkLocationPushdownSearch(params);
            const payload = result.payload;
            if (result.type === types.SEARCH_BULK_LOCATION_PUSHDOWN_SUCCESS) {
                this.setState({ searchResults: payload.locations });
                this.props.setSelectedLocations(payload.locations.slice());
            } else if (result.type === types.SEARCH_BULK_LOCATION_PUSHDOWN_FAILURE) {
                Notification("error", "An Error Occurred", payload.message)
            }
        } catch (error) {
            Notification("error", "An Error Occurred", error);
        } finally {
            this.setState({ isLoading: false });
        }
    }

    searchLocationsNoProject = async () => {
        try {
            this.setState({ isLoading: true });
            const params = {
                baselineId: this.props.baselineId,
                baselineTaskIdList: this.props.baselineTaskIds
            };
            
            const result = await this.props.baselineTaskActions.bulkLocationPushdownSearchNoProject(params);
            const payload = result.payload;
            if (result.type === types.SEARCH_BULK_LOCATION_PUSHDOWN_NO_PROJECT_SUCCESS) {
                this.setState({ searchResults: payload.locations });
                this.props.setSelectedLocations(payload.locations.slice());
            } else if (result.type === types.SEARCH_BULK_LOCATION_PUSHDOWN_NO_PROJECT_FAILURE) {
                Notification("error", "An Error Occurred", payload.message)
            }
        } catch (error) {
            Notification("error", "An Error Occurred", error);
        } finally {
            this.setState({ isLoading: false });
        }
    }

    render() {
        return (
            <div className="all-locations-form">
                <LoadingIndicator isLoading={this.state.isLoading}>
                    <div className="row">
                        <div className="col">
                            <span className="has-float-label">
                                <select id="locationsList" className="form-control" multiple size="25" disabled>
                                    {
                                        this.state.searchResults.map(loc => <option key={loc.id} value={loc.id}>{loc.name}</option>)
                                    }
                                </select>
                                <label htmlFor="locationsList">Locations to receive tasks</label>
                            </span>
                        </div>
                    </div>
                </LoadingIndicator>
            </div>
        );
    }
}

AllLocationsForm.propTypes = {
    setSelectedLocations: PropTypes.func.isRequired,
    baselineId: PropTypes.string.isRequired,
    baselineTaskIds: PropTypes.array.isRequired,
    baselineTaskActions: PropTypes.object.isRequired,
    projectId: PropTypes.string,
    isProjectsActive: PropTypes.bool.isRequired,
    isProjectIdRequiredForLocationTask: PropTypes.bool.isRequired
}

function mapDispatchToProps(dispatch) {
    return {
        baselineTaskActions: bindActionCreators(baselineTaskActions, dispatch)
    };
}

export default connect(null, mapDispatchToProps)(AllLocationsForm);